'use client';

import dynamic from 'next/dynamic';

// Defers loading `sonner` until after hydration. Toast notifications only
// fire in response to user actions (form submits, edit-mode saves), so we
// don't need this code in the LCP-critical chunk. `ssr: false` keeps the
// sonner runtime out of the SSR-streamed HTML and lets Next.js split it
// into its own async chunk.
const Toaster = dynamic(
  () => import('@/components/ui/sonner').then((mod) => mod.Toaster),
  { ssr: false },
);

export default function LazyToaster() {
  return <Toaster />;
}
